import { library, config, dom } from "@fortawesome/fontawesome-svg-core";

// this icon file is dynicly genereate by php
// conditionally get icons
// try {
//     const f = require("./icons-generated");
//     dynamicIcons = f.dynamicIcons;
// } catch (e) {
//     dynamicIcons = [];
// }

import { faShoppingCart } from "@fortawesome/sharp-light-svg-icons/faShoppingCart";
import { faUser } from "@fortawesome/sharp-light-svg-icons/faUser";
import { faEnvelope } from "@fortawesome/sharp-light-svg-icons/faEnvelope";
import { faArrowRight } from "@fortawesome/sharp-light-svg-icons/faArrowRight";
import { faArrowLeft } from "@fortawesome/sharp-light-svg-icons/faArrowLeft";
import { faBadgeCheck } from "@fortawesome/sharp-light-svg-icons/faBadgeCheck";
import { faCartShopping } from "@fortawesome/sharp-light-svg-icons/faCartShopping";
import { faCheck } from "@fortawesome/sharp-light-svg-icons/faCheck";
import { faBars } from "@fortawesome/sharp-light-svg-icons/faBars";
import { faSearch } from "@fortawesome/sharp-light-svg-icons/faSearch";
import { faShoppingBasket } from "@fortawesome/sharp-light-svg-icons/faShoppingBasket";
import { faAngleDown } from "@fortawesome/sharp-light-svg-icons/faAngleDown";
import { faAngleUp } from "@fortawesome/sharp-light-svg-icons/faAngleUp";
import { faTimes } from "@fortawesome/sharp-light-svg-icons/faTimes";
import { faBadgePercent } from "@fortawesome/sharp-light-svg-icons/faBadgePercent";
import { faPlus } from "@fortawesome/sharp-light-svg-icons/faPlus";
import { faMinus } from "@fortawesome/sharp-light-svg-icons/faMinus";
import { faChevronDown } from "@fortawesome/sharp-light-svg-icons/faChevronDown";
import { faSort } from "@fortawesome/sharp-light-svg-icons/faSort";
import { faStar } from "@fortawesome/sharp-light-svg-icons/faStar";
import { faInfoCircle } from "@fortawesome/sharp-light-svg-icons/faInfoCircle";
import { faBell } from "@fortawesome/sharp-light-svg-icons/faBell";
import { faSliders } from "@fortawesome/sharp-light-svg-icons/faSliders";
import { faTruck } from "@fortawesome/sharp-light-svg-icons/faTruck";
import { faBoxesStacked } from "@fortawesome/sharp-light-svg-icons/faBoxesStacked";
import { faPhone } from "@fortawesome/sharp-light-svg-icons/faPhone";
import { faTag } from "@fortawesome/sharp-light-svg-icons/faTag";
import { faBadgePercent } from "@fortawesome/sharp-light-svg-icons/faBadgePercent";

import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { faTiktok } from "@fortawesome/free-brands-svg-icons/faTiktok";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faFacebookMessenger } from "@fortawesome/free-brands-svg-icons/faFacebookMessenger";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";

const lightSharpcons = [
    faShoppingCart,
    faUser,
    faEnvelope,
    faArrowRight,
    faArrowLeft,
    faBadgeCheck,
    faCartShopping,
    faCheck,
    faBars,
    faSearch,
    faShoppingBasket,
    faAngleDown,
    faAngleUp,
    faTimes,
    faBadgePercent,
    faPlus,
    faMinus,
    faChevronDown,
    faSort,
    faInfoCircle,
    faStar,
    faBell,
    faSliders,
    faPhone,
    faTruck,
    faBoxesStacked,
    faTag,
    faBadgePercent,
];

const socialIcons = [
    faFacebookF,
    faTiktok,
    faInstagram,
    faFacebookMessenger,
    faLinkedinIn,
];

library.add([...lightSharpcons, ...socialIcons]);

config.searchPseudoElements = true;
dom.i2svg();
window.dom = dom;
//dom.watch(); // dont use this in production, really heave
